import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "../../../../middleware/api";
import OrdersTable from "./OrdersTable";
import Loading from "../../../Common/Loading/Loading";
import LoadingSpinner from "../../../Common/Loading/LoadingSpinner";
const Orders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await api.get("/orders/all");
                if (!response.data.success) {
                    setError(response.data.message);
                } else {
                    setOrders(response.data.orders);
                }
            } catch (err) {
                setError("Failed to fetch orders. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, []);

    if (loading) {
        return <LoadingSpinner style="medium" />;
    }

    if (error) {
        return <div className="text-center text-red-500 mt-10">{error}</div>;
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <OrdersTable orders={orders} setOrders={setOrders} />
        </div>
    );
};

export default Orders;
